import { useMemo } from 'react'

import { FixedBanner } from '@circlefin/components'
import { useTravelRuleRequired } from '@features/users/hooks/travel-rule'
import {
  RecipientAddressFilterBy,
  useBlockchainRecipientAddressesWithMetadataQuery,
} from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { PENDING_ADDRESS_STATES } from '../../utils'

export const PendingAddressesBanner: React.FC = () => {
  const { t } = useTranslation('address-book/components')
  const { travelRuleRequired } = useTravelRuleRequired()

  const { data } = useBlockchainRecipientAddressesWithMetadataQuery({
    variables: {
      filter: {
        show: RecipientAddressFilterBy.ALL_ADDRESSES,
        status: PENDING_ADDRESS_STATES,
      },
    },
  })

  const addressCount = useMemo(
    () => data?.blockchainRecipientAddressesWithMetadata.length ?? 0,

    [data?.blockchainRecipientAddressesWithMetadata],
  )

  const visible = useMemo(
    () => travelRuleRequired && addressCount > 0,
    [addressCount, travelRuleRequired],
  )

  return (
    <FixedBanner
      className="mb-10 grid gap-1"
      data-testid="verification-banner"
      status="warning"
      visible={visible}
    >
      <FixedBanner.Title>
        {t(`pendingAddressesBanner.title`, {
          count: addressCount,
        })}
      </FixedBanner.Title>
      <FixedBanner.Description>{t`pendingAddressesBanner.description`}</FixedBanner.Description>
    </FixedBanner>
  )
}
